<template>
    <div>
        <v-dialog
            :ref="modal.key"
            v-model="open"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card class="pa-0 ma-0">
                <v-toolbar dark dense color="primary" class="pl-6">
                    <v-toolbar-title>{{ modal.title }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-switch
                            dark
                            class="mt-3"
                            v-model="showMainDocument"
                            @change="loadMainDocument"
                            :label="$t('ShowMainDocument')"
                        ></v-switch>
                        <v-btn dark text class="ml-2" @click="hide()">{{
                            $t("Close")
                        }}</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text class="pa-0 ma-0">
                    <v-container class="py-0 my-0">
                        <v-row>
                            <v-col>
                                <PdfViewer
                                    :ref="viewerKey"
                                    :height="getHeight"
                                    :isSearchResult="false"
                                />
                            </v-col>
                            <v-col v-if="showMainDocument">
                                <PdfViewer
                                    :ref="mainDocumentViewerKey"
                                    :height="getHeight"
                                    :isSearchResult="false"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import DocumentService from '@/services/DocumentService';
import PdfViewer from '@/components/document/PdfViewer';
import { EventBus } from '@/eventBus.js';

export default {
    name: 'LinkedDocumentDisplayModal',
    components: {
        PdfViewer,
    },
    data() {
        return {
            modal: {
                title: '',
                key: 'LinkedDocumentDisplayModal',
            },
            showMainDocument: false,
            open: false,
            viewerKey: 'linkedDocumentPdfViewer',
            mainDocumentReRender: 0,
            linkedDocumentId: null,
            mainDocumentId: null,
        };
    },
    computed: {
        viewerInstance() {
            return this.$refs[this.viewerKey];
        },
        mainDocumentViewerKey() {
            return `linkedDocumentDocPdfViewer${this.mainDocumentReRender}`;
        },
        mainDocumentViewerInstance() {
            return this.$refs[this.mainDocumentViewerKey];
        },
        getHeight() {
            return window.innerHeight - 90;
        },
    },
    methods: {
        loadMainDocument() {
            localStorage.setItem('modalLinkedDocumentShowMainDocument', this.showMainDocument);
            if (this.showMainDocument) {
                this.mainDocumentReRender++;
                DocumentService.canDisplay(this.mainDocumentId).then(
                    async (canDisplay) => {
                        let file = encodeURIComponent('/static/defaultDocument.pdf');
                        if (canDisplay) {
                            const fileUrl = await DocumentService.display(this.mainDocumentId);
                            file = encodeURIComponent(fileUrl);
                        }
                        this.mainDocumentViewerInstance.load(file);
                    }
                );
            }
        },
        displayLinkedDocument(linkedDocument) {
            this.modal.title = linkedDocument.description ? linkedDocument.description : this.$t('Site.LinkedDocuments.Titles.LinkedDocuments');
            this.mainDocumentId = linkedDocument.mainDocumentId;
            this.linkedDocumentId = linkedDocument.linkedDocumentId;
            this.showMainDocument = localStorage.getItem('modalLinkedDocumentShowMainDocument') == 'true';
            this.loadMainDocument();
            this.show();

            DocumentService.canDisplay(this.linkedDocumentId).then(
                async (canDisplay) => {
                    let file = encodeURIComponent('/static/defaultDocument.pdf');
                    if (canDisplay) {
                        const fileUrl = await DocumentService.display(this.linkedDocumentId);
                        file = encodeURIComponent(fileUrl);
                    }
                    this.viewerInstance.load(file);
                }
            );
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
    mounted() {
        EventBus.$on('displayLinkedDocument', (linkedDocumentId) => {
            this.displayLinkedDocument(linkedDocumentId);
        });
    },
    destroyed() {
        EventBus.$off('displayLinkedDocument');
    },
};
</script>